import { Amplify } from 'aws-amplify';
import { env } from './env';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.COGNITO_USER_POOL_ID,
      userPoolClientId: env.COGNITO_USER_POOL_CLIENT_ID,
      region: env.AWS_REGION,
    },
  },
  API: {
    REST: {
      CarbonSpaceAPI: {
        endpoint: env.API_BASE_URL,
        region: env.AWS_REGION,
      },
    },
  },
};

export const configureAmplify = () => {
  Amplify.configure(amplifyConfig);
};

export default amplifyConfig;
